<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCursorDefaultClickOutline } from "@mdi/js";
export default {
  name: "MdiCursorDefaultClickOutline",
  data() {
    return {
      svgPath: mdiCursorDefaultClickOutline,
    };
  },
};
</script>
